export default __webpack_public_path__ + "static/media/multi-cloud-background.13be660f.png";